import compact from "lodash/compact";
import isEmpty from "lodash/isEmpty";
import { useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { RowType } from "PFApp/booking/types/row";
import { isProjects, isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import { BulkOperationFilter } from "PFCore/services/bookings_bulk_operation";

export const useTotalSelection = (): BulkOperationFilter[] => {
  const calendarRoot = useCalendarRoot();
  const rows = useBookingModuleStore((state) => state[calendarRoot].rows);
  const rootRowOriginalIds = useBookingModuleStore((state) =>
    state[calendarRoot].rows.filter(({ parents }) => isEmpty(parents)).map(({ original }) => original.id)
  );
  const allBookingsModeRowsState = useBookingModuleStore((state) =>
    isProjects(calendarRoot) ? state[calendarRoot].allBookingsModeRowsState : null
  );

  if (isWorkforceProfiles(calendarRoot)) {
    if (isEmpty(rootRowOriginalIds)) {
      return [];
    }

    return [
      {
        activityId: undefined,
        profileId: rootRowOriginalIds,
        includeChildren: false
      }
    ];
  } else {
    const profileIdsWithAllBookingsModeEnabled = compact(
      rows
        .filter(({ type, key }) => type === RowType.Profile && allBookingsModeRowsState?.[key] === "all")
        .map(({ original }) => original.id)
    );

    return [
      ...(!isEmpty(rootRowOriginalIds)
        ? [
            {
              activityId: rootRowOriginalIds,
              profileId: undefined,
              includeChildren: true
            }
          ]
        : []),
      ...(!isEmpty(profileIdsWithAllBookingsModeEnabled)
        ? [
            {
              activityId: undefined,
              profileId: profileIdsWithAllBookingsModeEnabled,
              includeChildren: false
            }
          ]
        : [])
    ];
  }
};
